module.exports = __webpack_public_path__ + "img/notice_2.ab3b5774.png";